import { forwardRef, ReactElement, Ref } from 'react'
import { GroupBase } from 'react-select'
import AsyncSelect from 'react-select/async'
import clsx from 'clsx'

import { SelectOption } from 'Components/Select/Select.types'

import { SelectAsyncProps } from './SelectAsync.types'

const ForwardSelectAsync = <
  Option extends SelectOption,
  IsMulti extends boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: SelectAsyncProps<Option, IsMulti, Group>,
  ref: Ref<any>,
) => {
  const { className, ...selectProps } = props

  return (
    <AsyncSelect
      ref={ref}
      className={clsx(
        'CustomReactSelect ReactSelect ReactSelect--async',
        className,
      )}
      classNamePrefix="ReactSelect"
      {...selectProps}
    />
  )
}

// forwardRef can't use generics. Workaround:
// https://stackoverflow.com/a/58473012
export const SelectAsync = forwardRef(ForwardSelectAsync) as <
  Option extends SelectOption,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: SelectAsyncProps<Option, IsMulti, Group> & { ref?: Ref<any> },
) => ReactElement
